<script setup lang="ts">
import type { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/vue-3';
import { Trash2 } from 'lucide-vue-next';
import { ref } from 'vue';
import { Button } from '@/components/ui/button';
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@/components/ui/popover';

const props = defineProps<NodeViewProps>();

const open = ref(false);
const localHeight = ref(props.node.attrs.height);

function applyHeight(e: Event) {
    const h = parseInt((e.target as HTMLInputElement).value, 10);
    localHeight.value = h;
    props.updateAttributes({ height: h });
}
</script>

<template>
    <NodeViewWrapper
        as="div"
        :style="`height: ${props.node.attrs.height}rem`"
        class="vertical-spacer-node group relative flex items-center justify-center"
        data-drag-handle
    >
        <!-- Visible only when selected or hovered -->
        <div
            :class="[
                'pointer-events-none absolute inset-x-0 top-1/2 h-px -translate-y-1/2 border-t border-dashed transition-opacity',
                props.selected
                    ? 'border-brand/60 opacity-100'
                    : 'border-muted-foreground/20 opacity-0 group-hover:opacity-100',
            ]"
        />

        <Popover v-model:open="open">
            <PopoverTrigger as-child>
                <Button
                    variant="ghost"
                    size="sm"
                    :class="[
                        'h-5 px-2 text-[10px] font-medium text-muted-foreground/60 opacity-0 transition-opacity group-hover:opacity-100',
                        props.selected ? 'opacity-100' : '',
                    ]"
                >
                    {{ props.node.attrs.height }}rem
                </Button>
            </PopoverTrigger>
            <PopoverContent class="w-56 p-3">
                <p class="mb-3 text-xs font-medium text-foreground">
                    Espacement vertical
                </p>
                <input
                    type="range"
                    :value="localHeight"
                    min="1"
                    max="12"
                    step="1"
                    class="w-full accent-brand"
                    @input="applyHeight"
                />
                <p class="mt-1 text-right text-[10px] text-muted-foreground">
                    {{ localHeight }}rem
                </p>
                <Button
                    variant="ghost"
                    size="sm"
                    class="mt-2 w-full gap-1.5 text-xs text-destructive hover:text-destructive"
                    @click="props.deleteNode()"
                >
                    <Trash2 class="h-3 w-3" />
                    Supprimer l’espaceur
                </Button>
            </PopoverContent>
        </Popover>
    </NodeViewWrapper>
</template>
